import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusFilter',
  pure: false

})
export class StatusFilterPipe implements PipeTransform {
  transform(items: any[], filter: string[] , filterBy:string): any {

    if (!items || !filter) {
      return items;
    }

    return items.filter(item => this.matchFilter(item, filter, filterBy));

  }

  matchFilter(item: any, filter: string[],filterBy:string): Boolean {
    if (filter.length === 0) {
      return true;
    }
    for (var i = 0; i < filter.length; i++) {
      if (item[filterBy].indexOf(filter[i]) !== -1) {
        return true;
      }
    }
    return false;
  }

}
